import toast from 'react-hot-toast';

export const showBonusToast = (premiaKwota, produktNazwa) => {
  if (premiaKwota <= 0) return;

  toast.success(
    `🏆 +${premiaKwota.toFixed(2)} zł premia (${produktNazwa})`,
    {
      duration: 3000,
      style: {
        background: '#22c55e',
        color: '#fff',
        fontWeight: '600',
        fontSize: '13px',
        padding: '10px 16px',
        borderRadius: '8px',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#22c55e',
      },
    }
  );
};

// For multiple products in one transaction
export const showBonusToastSummary = (totalPremia, produktyCount) => {
  if (totalPremia <= 0) return;

  toast.success(
    `🏆 Premia +${totalPremia.toFixed(2)} zł za ten paragon! (${produktyCount} produktów prem.)`,
    {
      duration: 4000,
      style: {
        background: '#22c55e',
        color: '#fff',
        fontWeight: '600',
        fontSize: '13px',
        padding: '10px 16px',
        borderRadius: '8px',
      },
    }
  );
};

export default { showBonusToast, showBonusToastSummary };
